module.exports = __webpack_public_path__ + "img/kehu_yuncangpei.45ca134d.png";